import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import CortActivationTool from './components/CortActivationTool';
import EntrataTestRun from './components/EntrataTestRun';
import ProcessPendingImports from './components/ProcessPendingImports';
import PostLastMonthsUsageFee from './components/PostLastMonthsUsageFee';

const QaToolsIndex = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">QA Tools</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link></h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader><strong>Entrata test run</strong></CardHeader>
            <CardBody>
              <EntrataTestRun />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <CortActivationTool />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader><strong>Process uploaded files now</strong></CardHeader>
            <CardBody>
              <ProcessPendingImports />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader><strong>Invoice preview: last month's usage fee, posted late</strong></CardHeader>
            <CardBody>
              <PostLastMonthsUsageFee />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default QaToolsIndex;
